import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Running inside Shopify admin (App Bridge loaded by index.html)
export const isEmbedded = () => {
  try { return sessionStorage.getItem("co_embedded") === "1" && !!window.shopify?.idToken; }
  catch { return false; }
};

// Navigate the top-level Shopify admin window (required for charges/plan pages)
export const openTop = (url) => {
  if (isEmbedded()) window.open(url, "_top");
  else window.location.href = url;
};

api.interceptors.request.use(async (config) => {
  if (isEmbedded()) {
    config.headers.Authorization = `Bearer ${await window.shopify.idToken()}`;
  }
  const sid = localStorage.getItem("cc_store_id");
  if (sid) config.headers["X-Store-Id"] = sid;
  return config;
});

// App Bridge asks for a retry with a fresh session token when one was rejected
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  if (cfg && !cfg._retried && error.response?.headers?.["x-shopify-retry-invalid-session-request"] === "1") {
    cfg._retried = true;
    return api(cfg);
  }
  return Promise.reject(error);
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function money(v, currency = "USD") {
  const n = Number(v || 0);
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(n);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

export default api;
